'use client';

import { AnimatePresence, motion } from 'framer-motion';
import React, { ReactNode, useRef, useEffect, useState } from 'react';
import { rollingVariants, childVariants } from '.';

const SlideUpAnimation = ({
  children,
  uniqueKey,
}: {
  children: ReactNode;
  uniqueKey: string | number;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setWidth(containerRef.current.scrollWidth);
    }
  }, [children]);

  // Function to split the content into characters
  const splitContentToChars = (content: ReactNode): string[] => {
    return content?.toString().split('') || [];
  };

  const content = splitContentToChars(children);

  return (
    <div className="relative h-6 overflow-hidden" style={{ width }}>
      <AnimatePresence initial={false}>
        <motion.div
          ref={containerRef}
          key={uniqueKey}
          initial="initial"
          animate="animate"
          exit="exit"
          variants={childVariants}
          className="absolute z-10 flex h-full shrink-0 items-center justify-center text-center"
          dir="ltr"
        >
          {content.map((digit, index) => (
            <motion.span
              key={index}
              custom={index}
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={rollingVariants}
              style={{ display: 'flex', fontWeight: 700 }}
            >
              {digit}
            </motion.span>
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default SlideUpAnimation;
